<template>
    <div class="row">
        <div class="col-md-4 form-group">
            <label for="user_name" class="control-label">Email*</label>
            <div class="input-container">
                <div class="spinner-border" role="status" v-if="loading"></div>
                <input class="form-control"  name="email" required type="text" v-model="email" @input="changed()" :readonly="loading"/>
            </div>

        </div>
        <div class="col-md-4 form-group">
            <label for="user_surname" class="control-label" >Nome*</label>
            <input class="form-control"  name="user_name" required type="text" :disabled="found" v-model="name"/>
        </div>
        <div class="col-md-4 form-group">
            <label for="user_email" class="control-label" >Cognome*</label>
            <input class="form-control"  name="user_surname" required type="text" :disabled="found" v-model="surname"/>
        </div>
        <input class="form-control"  name="user_id" type="hidden" v-model="user_id"/>
    </div>
</template>

<script>
export default {
    props: {
    },
    data(){
        return {
            email: "",
            name: "",
            surname: "",
            loading: false,
            timeout: null,
            found: true,
            user_id: 0
        }
    },
    mounted() {},
    beforeDestroy() {},
    methods: {
        changed() {
            clearTimeout(this.timeout);

            if (this.email.length > 4) {
                this.timeout = setTimeout(() => {
                    this.loading = true;
                    axios.get('/check-existing-mail', {params: { email: this.email }})
                        .then((response) => {
                            if(response.data && response.data.name && response.data.surname)
                            {
                                this.name = response.data.name;
                                this.surname = response.data.surname;
                                this.user_id = response.data.id;
                                this.found = true;
                            }
                            else
                            {
                                this.name = "";
                                this.surname = "";
                                this.user_id = 0;
                                this.found = false
                            }

                        })
                        .catch((err) => {
                            console.error(err);
                            this.found = false;
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }, 1000);
            }
        }

        },
    watch: {}
}
</script>
<style scoped>
.spinner-border {
    display: inline-block;
    width: 2rem;
    height: 2rem;
    vertical-align: text-bottom;
    border: 0.25em solid #f9834e;
    border-right-color: transparent;
    border-radius: 50%;
    animation: spinner-border 0.75s linear infinite;
    position: absolute;
    top: 8px;
    right: 8px;
}

.input-container {
    position: relative;
}

@keyframes spinner-border {
    100% {
        transform: rotate(360deg);
    }
}
</style>


// WEBPACK FOOTER //
// resources/js/admin-panel/components/admin/orders/userAutocomplete.vue